"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = process.env.EXPO_ROUTER_IMPORT_MODE || 'sync';
//# sourceMappingURL=index.js.map